/**
 * Policy API - Complete implementation matching trace-api.alpyne.ai/docs
 */

import { getAPIClient } from './client';

export interface PolicyPack {
  id: string;
  tenant_id: string | null;
  name: string;
  version: string;
  description: string | null;
  rules: Record<string, any>;
  policy_data?: Record<string, any>; // Legacy field, use rules instead
  disclosure_text: string | null;
  created_at: string;
  updated_at: string;
}

export interface PolicyValidationResult {
  valid: boolean;
  errors: string[];  // Backend returns List[str], not structured objects
  warnings: string[];
  policy_name?: string | null;
  policy_version?: string | null;
}

// Create policy pack
export async function createPolicyPack(file: File): Promise<PolicyPack> {
  const client = getAPIClient();
  const formData = new FormData();
  formData.append('file', file);
  return client.upload<PolicyPack>('/policy/packs', formData);
}

// List policy packs
export async function listPolicyPacks(tenantId?: string): Promise<PolicyPack[]> {
  const client = getAPIClient();
  console.log('[API] Listing policy packs, tenant:', tenantId);
  const result = await client.get<PolicyPack[]>('/policy/packs', {
    params: tenantId ? { tenant_id: tenantId } : undefined,
  });
  console.log('[API] Policy packs result:', result);
  return Array.isArray(result) ? result : [];
}

// Get policy pack
export async function getPolicyPack(policyPackId: string): Promise<PolicyPack> {
  const client = getAPIClient();
  return client.get<PolicyPack>(`/policy/packs/${policyPackId}`);
}

// Delete policy pack
export async function deletePolicyPack(policyPackId: string): Promise<void> {
  const client = getAPIClient();
  return client.delete(`/policy/packs/${policyPackId}`);
}

// Validate policy pack
export async function validatePolicyPack(file: File): Promise<PolicyValidationResult> {
  const client = getAPIClient();
  const formData = new FormData();
  formData.append('file', file);
  return client.upload<PolicyValidationResult>('/policy/validate', formData);
}

